import { useTheme } from 'antd-style'
import { Tree } from 'react-organizational-chart'

import { GetInstitutionHierarchyResponse } from 'src/api/requests'
import { flattenArray } from 'src/utils'

import { List } from './components'
import { GroupNode } from './components/GroupNode'

export type Props = {
  data: GetInstitutionHierarchyResponse
  onAddChild: (parentId: string) => void
}

export const OrganizationalChart = ({ data, onAddChild }: Props) => {
  const theme = useTheme()

  return (
    <Tree
      lineWidth="3px"
      nodePadding="42px"
      lineBorderRadius="12px"
      lineHeight="30px"
      lineColor={theme.colorSplit}
      label={
        <GroupNode
          idx={0}
          node={data}
          length={flattenArray(data?.children ?? [], 'children')?.length}
          onAddChild={onAddChild}
        />
      }
    >
      {data?.children?.map((list, idx) => (
        <List
          key={list.name}
          depth={1}
          data={list}
          idx={idx}
          onAddChild={onAddChild}
        />
      ))}
    </Tree>
  )
}
